import React from "react";
import EnrichedPlayerPlugin from "../../EnrichedPlayer/components/EnrichedPlayerPlugin.js";
import AvatarFrame from "../AvatarFrame";
/* eslint-disable react/prop-types */

/**
 * AvatarPlayer — visor twin. One box, two states.
 *
 *   no clip yet  -> AvatarFrame: the still presenter, cover-cropped.
 *   animated     -> EnrichedPlayerPlugin, the SAME component a real video box
 *                   uses.
 *
 * Delegating rather than rendering our own <video> is what makes the export
 * work. EnrichedPlayerPlugin branches into RecorderCanvasVideo under
 * `?recorderMode=true`, which demuxes with mp4box and decodes with WebCodecs so
 * the seek-and-screenshot loop gets the right frame instead of a stale one. Our
 * clips are opaque H.264 MP4 — exactly what that renderer was built for — so the
 * limitations that make it useless for alpha video simply do not apply here.
 *
 * The box still has to be ANNOUNCED to the visor as a video box: see the
 * `AvatarPlayer` branches added alongside `EnrichedPlayer` in VisorApp (the
 * recorder readiness gate above all) and in the export audio manifest.
 */
export function AvatarPlayer(base) {
  return {
    getRenderTemplate: function (state, props) {
      const hasClip = Boolean(state?.videoUrl) && state?.jobStatus === "done";

      if (!hasClip) {
        return <AvatarFrame state={state} props={props} />;
      }

      // EnrichedPlayerPlugin reads `state.url`; the avatar keeps its clip under
      // `videoUrl` so the poster stays addressable for re-animation and for the
      // editor's own preview.
      const playerState = {
        ...state,
        url: state.videoUrl,
        controls: false,
        autoPlay: true,
        loop: false,
        volume: 1,
      };

      return (
        <div
          className="avatar-player-frame avatar-player-frame--clip"
          style={{ width: "100%", height: "100%" }}
        >
          <EnrichedPlayerPlugin
            style={{ width: "100%", height: "100%" }}
            state={playerState}
            props={props}
          />
        </div>
      );
    },
  };
}
